if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden",
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              // window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden",
            );

            const cartChangeEvent = new CustomEvent('addToCartComplete');
            window.dispatchEvent(cartChangeEvent);

            if (document.querySelector(".gift-tracker") != null) {
              let productForm = this;
              const url = new URL(window.location.href);
              url.searchParams.set(
                "section_id",
                productForm.closest("section").dataset.section,
              );

              fetch(url.toString())
                .then((response) => response.text())
                .then((responseText) => {
                  const elementToReplace =
                    document.querySelector(".gift-tracker");
                  const html = new DOMParser().parseFromString(
                    responseText,
                    "text/html",
                  );
                  const replacement = html.querySelector(".gift-tracker");
                  elementToReplace.replaceWith(replacement);
                });
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );

  //   const styleSheet = new CSSStyleSheet();
  //   styleSheet.replaceSync(`
  //   .another-tier-card {
  //     border-color:#000;
  //   }
  //   .another-tier-card:hover {
  //     border-color:#000;
  //   }

  //   .another-tier-card.selected:hover {
  //     border-color:#FEAE34!important;
  //   }

  //   .another-tier-card.selected {
  //     border-color:#FEAE34!important;
  //     background:rgba(254, 174, 52, 0.35)!important;
  //   }

  //   .another-tier-card-radio-button, another-price {
  //     display:none;
  //   }

  //   .another-tier-card {
  //     flex-direction:row!important;
  //     justify-content:space-between!important;
  //     align-items:center!important;
  //     text-align:start!important;
  //     padding:12px!important;
  //   }

  //   another-tier-badge {
  //     position:relative!important;
  //     order:1;
  //     right:unset!important;
  //     top:unset!important;
  //     font-family: 'Open Sans'!important;
  //     font-size: 10px!important;
  //     text-transform: uppercase!important;
  //     letter-spacing: normal!important;
  //     border-radius: 4px!important;
  //     padding: 4px 8px!important;
  //   }

  //   another-title-subtitle div:first-child {
  //     font-size:14px!important;
  //     margin-bottom:4px;
  //     font-family: 'Open Sans', sans-serif!important;
  //   }

  //   div div:first-child {
  //     font-family: "Open Sans", sans-serif !important;
  //     text-align: left!important;
  //     font-size: 14px;
  //     font-weight: 600!important;
  //   }

  // `);

  // window.selectedTier = "";
  // const shadow = document?.querySelector("another-container")?.shadowRoot;
  //Attach stylesheets to qty break widget & attach event listeners to watch for pricing changes
  // if (shadow) {
  //   document.querySelector("body").classList.add("qty-breaks", "widget-loading");
  //   shadow.adoptedStyleSheets = [styleSheet];
  //   let selectedTierOption = shadow
  //     .querySelector(".another-tier-card.selected")
  //     .closest("another-tier-card").tier;
  //   window.selectedTier = selectedTierOption;

  //   const checkforSealSubs = setInterval(() => {
  //     if (typeof sealsubsloaded !== "undefined") {
  //       clearInterval(checkforSealSubs);

  //       const attachSealEventListeners = setInterval(() => {
  //         const container = document.querySelector(".sealsubs-container");
  //         if (container) {
  //           container.addEventListener("click", (e) => {
  //             if (!container.contains(e.target)) return;

  //             setTimeout(() => {
  //               calculateSubscriptionPrices();
  //             }, 50);
  //           });

  //           document.body.classList.remove("widget-loading");
  //           setTimeout(() => {
  //           calculateSubscriptionPrices();
  //           }, 500)
  //           clearInterval(attachSealEventListeners);
  //         }
  //       }, 100);
  //     }
  //   }, 100);

  //   // Listen for click events inside bulk discount widget & update product prices accordingly
  //   shadow.addEventListener("click", (e) => {
  //     let selectedTierOption = e.target
  //       .closest(".another-tier-card.selected")
  //       .closest("another-tier-card").tier;
  //     // console.log("selectedTierOption:", selectedTierOption);
  //     window.selectedTier = selectedTierOption;
  //     // console.log("Subscription changed");
  //     calculateSubscriptionPrices();
  //   });
  // }

  // Calculate & update prices inside sealsubs widget
  // function calculateSubscriptionPrices() {
  //   const basePriceCents = window.productData.price;
  //   const quantity = selectedTier.quantity;
  //   const discountAmount = selectedTier.discountAmount;

  //   const discountMultiplier = 1 - discountAmount / 100;

  //   const oneTimeCents = Math.round(
  //     basePriceCents * quantity * discountMultiplier
  //   );
  //   const subscriptionCents = Math.round(
  //     basePriceCents * quantity * discountMultiplier * 0.9
  //   );

  //   const oneTimePrice = (oneTimeCents / 100).toFixed(2);
  //   const subscriptPrice = (subscriptionCents / 100).toFixed(2);

  //   document.querySelector(".sls-one-time-price .ht-money").textContent = `A$${oneTimePrice}`;
  //   document.querySelector(".sls-selling-plan-group-price .ht-money").textContent = `A$${subscriptPrice}`;
  // }
}
